// extracted by mini-css-extract-plugin
module.exports = {"pressInfo":"PressInfo_pressInfo__2DXPk","button":"PressInfo_button__3_7gx","info":"PressInfo_info__2JdfN","img":"PressInfo_img__ntziP","perssInfo":"PressInfo_perssInfo__fzvcC"};